/** Controls the number of results to show for tables using pagination. */
export const PAGINATION_LIMIT = 50;

export const MILLISECONDS_PER_SECOND = 1000;
